import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { FiTrash } from 'react-icons/fi';
import ModalWrapper from '../../elements/ModalWrapper';
import Button from '../../elements/Button';
import { ModalDeleteProps } from '../ModalApproved';

const ModalDelete: React.FC<ModalDeleteProps> = ({
  isVisible,
  onClose,
  onConfirmation,
  title,
  loading,
  cancelText,
  confirmationText
}) => {
  return (
    <ModalWrapper
      title={`Delete ${title || 'Data'}`}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className="wrapper-modal-delete">
        <div className="wrapper-modal-delete__content">
          <p className="m-0">
            are you sure want to delete this{' '}
            <span style={{ textTransform: 'lowercase' }}>{title}</span>?
          </p>
          <div className="wrapper-modal-delete__content__actions">
            <Button variant="error-beelajar" onClick={() => onClose()}>
              {cancelText || 'Cancel'}
            </Button>
            <Button
              variant="error"
              disabled={loading}
              loading={loading}
              onClick={() => onConfirmation()}
            >
              {confirmationText || (
                <>
                  <FiTrash /> Delete
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ModalDelete;
